import { render, staticRenderFns } from "./ClientLandingPages.vue?vue&type=template&id=1097989c&scoped=true&"
import script from "./ClientLandingPages.vue?vue&type=script&lang=js&"
export * from "./ClientLandingPages.vue?vue&type=script&lang=js&"
import style0 from "./ClientLandingPages.vue?vue&type=style&index=0&id=1097989c&scoped=true&lang=css&"
import style1 from "./ClientLandingPages.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1097989c",
  null
  
)

export default component.exports